import { render } from "./OverlayLoader.vue?vue&type=template&id=e45f1fe6"
import script from "./OverlayLoader.vue?vue&type=script&lang=js"
export * from "./OverlayLoader.vue?vue&type=script&lang=js"

import "./OverlayLoader.vue?vue&type=style&index=0&id=e45f1fe6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__